import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import { mainSiteUrl } from "@/mocks/categories";

const siteUrl = "https://sugargoosheet.casa";

const collectionSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Sugargoo Shopping Guide & Resource Hub",
  description: "Everything you need to master Sugargoo — from product research and spreadsheets to shipping optimization, coupon strategies, and safety guides.",
  url: `${siteUrl}/shopping-guide`,
  inLanguage: "en",
  isPartOf: {
    "@type": "WebSite",
    name: "Sugargoo Spreadsheet",
    url: siteUrl,
  },
};

const guideArticles = [
  {
    path: "/blog/sugargoo-spreadsheet-complete-guide",
    title: "Sugargoo Spreadsheet Complete Guide 2026",
    desc: "Everything you need to know about using Sugargoo Spreadsheet — from getting started to advanced product research strategies.",
    tag: "Ultimate Guide",
    image: "https://readdy.ai/api/search-image?query=Professional%20organized%20workspace%20with%20multiple%20product%20samples%20sneakers%20clothing%20accessories%20arranged%20on%20clean%20white%20desk%20with%20laptop%20displaying%20spreadsheet%20data%20warm%20natural%20lighting%20editorial%20productivity%20scene%20minimalist%20modern%20aesthetic&width=800&height=500&seq=shop-guide-card-01&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-review-2026",
    title: "Sugargoo Review 2026: Is It Legit or a Scam?",
    desc: "Honest, in-depth review covering features, pricing, shipping, safety, and user experience. Updated for 2026.",
    tag: "Review",
    image: "https://readdy.ai/api/search-image?query=Elegant%20modern%20ecommerce%20product%20photography%20with%20stylish%20leather%20handbag%20designer%20watch%20gold%20jewelry%20on%20marble%20surface%20with%20natural%20lighting%20luxurious%20editorial%20composition%20minimal%20clean%20background%20soft%20warm%20shadows%20professional%20catalog%20style&width=800&height=500&seq=shop-guide-card-02&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-shipping-cost-guide",
    title: "Sugargoo Shipping Cost Guide: Cheapest Methods Compared",
    desc: "Complete breakdown of international shipping costs, carrier options, delivery times, and money-saving strategies.",
    tag: "Shipping",
    image: "https://readdy.ai/api/search-image?query=Professional%20logistics%20and%20shipping%20concept%20photography%20cardboard%20boxes%20packages%20with%20shipping%20labels%20on%20clean%20white%20desk%20natural%20light%20minimal%20workspace%20modern%20warehouse%20aesthetic%20well%20organized%20parcels%20warm%20editorial%20style&width=800&height=500&seq=shop-guide-card-03&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-coupon-discount-guide",
    title: "Sugargoo Coupon Codes & Discount Guide 2026",
    desc: "Find the latest coupon codes, discount strategies, promo deals, and money-saving tips for Sugargoo.",
    tag: "Savings",
    image: "https://readdy.ai/api/search-image?query=Stylish%20shopping%20discount%20concept%20photography%20with%20fashion%20accessories%20sunglasses%20scarf%20and%20designer%20wallet%20next%20to%20coupon%20tags%20on%20minimal%20pastel%20pink%20background%20soft%20natural%20lighting%20elegant%20editorial%20style%20clean%20composition&width=800&height=500&seq=shop-guide-card-04&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-warehouse-guide",
    title: "Sugargoo Warehouse Guide: Storage, QC & Processing",
    desc: "Everything about Sugargoo warehouse — storage time limits, quality inspection, package consolidation, and tips.",
    tag: "Warehouse",
    image: "https://readdy.ai/api/search-image?query=Modern%20organized%20warehouse%20interior%20with%20shelves%20of%20packaged%20products%20cardboard%20boxes%20neatly%20stacked%20clean%20bright%20industrial%20space%20with%20natural%20light%20coming%20through%20windows%20professional%20logistics%20environment%20minimal%20design&width=800&height=500&seq=shop-guide-card-05&orientation=landscape",
  },
  {
    path: "/blog/is-sugargoo-legit",
    title: "Is Sugargoo Legit? Complete Safety Analysis",
    desc: "Thorough investigation into Sugargoo's legitimacy — security, company background, user experiences, and risk analysis.",
    tag: "Safety",
    image: "https://readdy.ai/api/search-image?query=Professional%20security%20and%20trust%20concept%20photography%20with%20gold%20padlock%20on%20clean%20white%20minimal%20desk%20next%20to%20certificate%20documents%20natural%20soft%20lighting%20warm%20atmosphere%20reassuring%20editorial%20style%20modern%20composition&width=800&height=500&seq=shop-guide-card-06&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-spreadsheet-for-beginners",
    title: "Sugargoo Spreadsheet for Beginners",
    desc: "A beginner-friendly guide to using Sugargoo Spreadsheet. No prior experience needed — start sourcing in 10 minutes.",
    tag: "Beginner",
    image: "https://readdy.ai/api/search-image?query=Warm%20inviting%20beginners%20workspace%20with%20open%20laptop%20notebook%20coffee%20cup%20and%20colorful%20sticky%20notes%20on%20clean%20wooden%20desk%20natural%20morning%20light%20streaming%20through%20window%20cozy%20learning%20atmosphere%20minimal%20aesthetic&width=800&height=500&seq=shop-guide-card-07&orientation=landscape",
  },
  {
    path: "/blog/how-to-find-winning-products",
    title: "How to Find Winning Products With Sugargoo Spreadsheet",
    desc: "Proven methodology for identifying trending, profitable products before your competitors discover them.",
    tag: "Strategy",
    image: "https://readdy.ai/api/search-image?query=Fashion%20trend%20research%20workspace%20with%20magazine%20cutouts%20fabric%20swatches%20product%20photos%20and%20analytics%20charts%20on%20clean%20desk%20creative%20mood%20board%20natural%20lighting%20modern%20design%20studio%20aesthetic%20minimal%20editorial%20style&width=800&height=500&seq=shop-guide-card-08&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-spreadsheet-for-dropshipping",
    title: "Sugargoo Spreadsheet for Dropshipping",
    desc: "How dropshippers can leverage the Sugargoo Spreadsheet to find products faster and build a profitable business.",
    tag: "Dropshipping",
    image: "https://readdy.ai/api/search-image?query=Modern%20ecommerce%20dropshipping%20workspace%20with%20laptop%20showing%20online%20store%20dashboard%20surrounded%20by%20product%20samples%20packaging%20materials%20and%20shipping%20boxes%20on%20minimal%20desk%20natural%20lighting%20professional%20home%20office%20aesthetic&width=800&height=500&seq=shop-guide-card-09&orientation=landscape",
  },
  {
    path: "/blog/china-shopping-tips",
    title: "China Shopping Tips: Smart Sourcing Strategies",
    desc: "Expert tips for navigating Chinese e-commerce platforms, avoiding pitfalls, and maximizing value when sourcing.",
    tag: "Tips",
    image: "https://readdy.ai/api/search-image?query=World%20map%20with%20shopping%20icons%20and%20product%20parcels%20scattered%20on%20clean%20desk%20global%20ecommerce%20concept%20photography%20with%20warm%20lighting%20modern%20minimal%20workspace%20international%20shopping%20theme%20editorial%20style&width=800&height=500&seq=shop-guide-card-10&orientation=landscape",
  },
];

export default function ShoppingGuide() {
  return (
    <>
      <JsonLd data={collectionSchema} />
      <Navbar />
      <main>
        <section className="pt-24 md:pt-28 pb-16 md:pb-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-block text-xs font-semibold text-primary-500 uppercase tracking-wider bg-primary-50 px-3 py-1 rounded-full mb-4">Shopping Guide</span>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
                Sugargoo Shopping Guide &amp; Resource Hub
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                Everything you need to master Sugargoo — from product research and spreadsheets to shipping optimization, coupon strategies, and safety guides. Start here for complete China sourcing knowledge.
              </p>
              <div className="mt-6">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer">
                  Get Sugargoo Spreadsheet <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {guideArticles.map((article) => (
                <Link
                  key={article.path}
                  to={article.path}
                  className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 hover:shadow-md transition-all duration-200"
                >
                  <div className="w-full h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full mb-2">{article.tag}</span>
                    <h2 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{article.title}</h2>
                    <p className="text-xs text-foreground-500 leading-relaxed">{article.desc}</p>
                  </div>
                </Link>
              ))}
            </div>

            <div className="mt-12 pt-10 border-t border-background-200/70 text-center">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">Ready to Start Shopping?</h2>
              <p className="text-sm text-foreground-500 max-w-md mx-auto mb-6">
                Pair these guides with the Sugargoo Spreadsheet for the ultimate China sourcing experience.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer">
                  Sugargoo Spreadsheet
                </a>
                <Link to="/" className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-700 border border-background-300 hover:bg-background-100 rounded-lg transition-all duration-200 whitespace-nowrap">
                  Back to Homepage
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}